module.exports = __webpack_public_path__ + "static/media/2_eoru_free_1135.6442d6f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2_eoru_free_1135.jpg
// module id = 61
// module chunks = 0